import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

export const MusicToggle = () => {
  const audioRef = useRef(null);
  const userMuted = useRef(false);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const a = new Audio("/audio/pink-panther.mp3");
    a.loop = true;
    a.volume = 0.35;
    audioRef.current = a;
    a.play().then(() => setPlaying(true)).catch(() => {});
    const events = ["pointerdown", "touchstart", "touchend", "scroll", "keydown"];
    const tryStart = () => {
      if (!userMuted.current && a.paused) {
        a.play().then(() => {
          setPlaying(true);
          events.forEach((e) => window.removeEventListener(e, tryStart));
        }).catch(() => {});
      } else {
        events.forEach((e) => window.removeEventListener(e, tryStart));
      }
    };
    events.forEach((e) => window.addEventListener(e, tryStart, { passive: true }));
    const onVis = () => tryStart();
    document.addEventListener("visibilitychange", onVis);
    return () => {
      a.pause();
      events.forEach((e) => window.removeEventListener(e, tryStart));
      document.removeEventListener("visibilitychange", onVis);
    };
  }, []);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (!a.paused) {
      userMuted.current = true;
      a.pause();
      setPlaying(false);
    } else {
      userMuted.current = false;
      a.play().then(() => setPlaying(true)).catch(() => {});
    }
  };

  return (
    <button
      data-testid="music-toggle-button"
      onClick={toggle}
      aria-label={playing ? "Mute theme music" : "Play theme music"}
      title="The Pink Panther Theme"
      className="fixed bottom-5 right-5 z-50 w-12 h-12 rounded-full bg-navy text-white flex items-center justify-center shadow-xl hover:bg-tpink transition-colors duration-300"
    >
      {playing ? <Volume2 className="w-5 h-5" /> : <VolumeX className="w-5 h-5" />}
      {playing && (
        <span className="absolute inset-0 rounded-full border-2 border-tpink animate-ping opacity-40 pointer-events-none" />
      )}
    </button>
  );
};
